import React, { useEffect, useRef, useState } from 'react';
import styles from './InfluencerReelCard.module.css';
import type { InfluencerReelCardProps } from './InfluencerReelCard.types';

export const InfluencerReelCard: React.FC<InfluencerReelCardProps> = ({
  video,
  onClick,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    const videoNode = videoRef.current;
    if (videoNode) {
      videoNode.play().catch((err) => {
        console.warn('Autoplay preview video failed to play:', err);
      });
    }
  }, []);

  const handleLoadedData = (): void => {
    setIsLoaded(true);
  };

  return (
    <div className={styles.card} onClick={onClick}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className={`${styles.video} ${isLoaded ? styles.loaded : ''}`}
        ref={videoRef}
        src={video.videoUrl}
        onLoadedData={handleLoadedData}
      />

      {video.thumbnailUrl && !isLoaded && (
        <img
          src={video.thumbnailUrl}
          alt={video.title || 'Influencer pick preview'}
          className={styles.thumbnail}
        />
      )}
    </div>
  );
};

export default InfluencerReelCard;
